import { createContext as T, useContext as M, useState as A, useCallback as k, useRef as S, useLayoutEffect as z, useEffect as J } from "react";
import { jsx as b } from "react/jsx-runtime";
const j = ["shift", "alt", "meta", "mod", "ctrl", "control"], Q = {
  esc: "escape",
  return: "enter",
  left: "arrowleft",
  right: "arrowright",
  up: "arrowup",
  down: "arrowdown",
  ShiftLeft: "shift",
  ShiftRight: "shift",
  AltLeft: "alt",
  AltRight: "alt",
  MetaLeft: "meta",
  MetaRight: "meta",
  OSLeft: "meta",
  OSRight: "meta",
  ControlLeft: "ctrl",
  ControlRight: "ctrl"
};
function K(e) {
  return (Q[e.trim()] || e.trim()).toLowerCase().replace(/key|digit|numpad/, "");
}
function D(e) {
  return j.includes(e);
}
function H(e, n = ",") {
  return e.toLowerCase().split(n);
}
function P(e, n = "+", r = ">", i = !1, u, f) {
  let o = [], y = !1;
  e = e.trim(), e.includes(r) ? (y = !0, o = e.toLocaleLowerCase().split(r).map((d) => K(d))) : o = e.toLocaleLowerCase().split(n).map((d) => K(d));
  const c = {
    alt: o.includes("alt"),
    ctrl: o.includes("ctrl") || o.includes("control"),
    shift: o.includes("shift"),
    meta: o.includes("meta"),
    mod: o.includes("mod"),
    useKey: i
  }, m = o.filter((d) => !j.includes(d));
  return {
    ...c,
    keys: m,
    description: u,
    isSequence: y,
    hotkey: e,
    metadata: f
  };
}
typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.code !== void 0 && _([K(e.code)]);
}), document.addEventListener("keyup", (e) => {
  e.code !== void 0 && I([K(e.code)]);
})), typeof window < "u" && (window.addEventListener("blur", () => {
  L.clear();
}), window.addEventListener("contextmenu", () => {
  setTimeout(() => {
    L.clear();
  }, 0);
}));
const L = /* @__PURE__ */ new Set();
function R(e) {
  return Array.isArray(e);
}
function U(e, n = ",") {
  return (R(e) ? e : e.split(n)).every((i) => L.has(i.trim().toLowerCase()));
}
function _(e) {
  const n = Array.isArray(e) ? e : [e];
  L.has("meta") && L.forEach((r) => {
    D(r) || L.delete(r.toLowerCase());
  }), n.forEach((r) => {
    L.add(r.toLowerCase());
  });
}
function I(e) {
  const n = Array.isArray(e) ? e : [e];
  e === "meta" ? L.clear() : n.forEach((r) => {
    L.delete(r.toLowerCase());
  });
}
function V(e, n, r) {
  (typeof r == "function" && r(e, n) || r === !0) && e.preventDefault();
}
function X(e, n, r) {
  return typeof r == "function" ? r(e, n) : r === !0 || r === void 0;
}
const Y = [
  "input",
  "textarea",
  "select",
  "searchbox",
  "slider",
  "spinbutton",
  "menuitem",
  "menuitemcheckbox",
  "menuitemradio",
  "option",
  "radio",
  "textbox"
];
function Z(e) {
  return F(e, Y);
}
function F(e, n = !1) {
  const { target: r, composed: i } = e;
  let u, f;
  return ee(r) && i ? (u = e.composedPath()[0] && e.composedPath()[0].tagName, f = e.composedPath()[0] && e.composedPath()[0].role) : (u = r && r.tagName, f = r && r.role), R(n) ? !!(u && n && n.some((o) => o.toLowerCase() === u.toLowerCase() || o === f)) : !!(u && n && n);
}
function ee(e) {
  return !!e.tagName && !e.tagName.startsWith("-") && e.tagName.includes("-");
}
function te(e, n) {
  return e.length === 0 && n ? !1 : n ? e.some((r) => n.includes(r)) || e.includes("*") : !0;
}
const re = (e, n, r = !1) => {
  const { alt: i, meta: u, mod: f, shift: o, ctrl: y, keys: c, useKey: m } = n, { code: d, key: t, ctrlKey: a, metaKey: l, shiftKey: h, altKey: w } = e, p = K(d);
  if (m) {
    if (c?.length === 1 && c.includes(t.toLowerCase())) {
      if (!r) {
        if (i !== w || o !== h) return !1;
        if (f) {
          if (!l && !a) return !1;
        } else if (u !== l || y !== a) return !1;
      }
      return !0;
    }
    return !1;
  }
  if (!c?.includes(p) && !["ctrl", "control", "unknown", "meta", "alt", "shift", "os"].includes(p))
    return !1;
  if (!r) {
    if (i !== w && p !== "alt" || o !== h && p !== "shift")
      return !1;
    if (f) {
      if (!l && !a)
        return !1;
    } else if (u !== l && p !== "meta" && p !== "os" || y !== a && p !== "ctrl" && p !== "control")
      return !1;
  }
  return c && c.length === 1 && c.includes(p) ? !0 : c && c.length > 0 ? c.includes(p) ? U(c) : !1 : !c || c.length === 0;
}, $ = T(void 0), ne = () => M($);
function oe({ addHotkey: e, removeHotkey: n, children: r }) {
  return /* @__PURE__ */ b($.Provider, { value: { addHotkey: e, removeHotkey: n }, children: r });
}
function x(e, n) {
  return e && n && typeof e == "object" && typeof n == "object" ? Object.keys(e).length === Object.keys(n).length && // @ts-expect-error TS7053
  Object.keys(e).reduce((r, i) => r && x(e[i], n[i]), !0) : e === n;
}
const W = T({
  hotkeys: [],
  activeScopes: [],
  // This array has to be empty instead of containing '*' as default, to check if the provider is set or not
  toggleScope: () => {
  },
  enableScope: () => {
  },
  disableScope: () => {
  }
}), se = () => M(W), fe = ({ initiallyActiveScopes: e = ["*"], children: n }) => {
  const [r, i] = A(e), [u, f] = A([]), o = k((t) => {
    i((a) => a.includes("*") ? [t] : Array.from(/* @__PURE__ */ new Set([...a, t])));
  }, []), y = k((t) => {
    i((a) => a.filter((l) => l !== t));
  }, []), c = k((t) => {
    i((a) => a.includes(t) ? a.filter((l) => l !== t) : a.includes("*") ? [t] : Array.from(/* @__PURE__ */ new Set([...a, t])));
  }, []), m = k((t) => {
    f((a) => [...a, t]);
  }, []), d = k((t) => {
    f((a) => a.filter((l) => !x(l, t)));
  }, []);
  return /* @__PURE__ */ b(
    W.Provider,
    {
      value: { activeScopes: r, hotkeys: u, enableScope: o, disableScope: y, toggleScope: c },
      children: /* @__PURE__ */ b(oe, { addHotkey: m, removeHotkey: d, children: n })
    }
  );
};
function ie(e) {
  const n = S(void 0);
  return x(n.current, e) || (n.current = e), n.current;
}
const N = (e) => {
  e.stopPropagation(), e.preventDefault(), e.stopImmediatePropagation();
}, ue = typeof window < "u" ? z : J;
function de(e, n, r, i) {
  const u = S(null), f = S(!1), o = Array.isArray(r) ? Array.isArray(i) ? void 0 : i : r, y = R(e) ? e.join(o?.delimiter) : e, c = Array.isArray(r) ? r : Array.isArray(i) ? i : void 0, m = k(n, c ?? []), d = S(m);
  c ? d.current = m : d.current = n;
  const t = ie(o), { activeScopes: a } = se(), l = ne();
  return ue(() => {
    if (t?.enabled === !1 || !te(a, t?.scopes))
      return;
    let h = [], w;
    const p = (s, B = !1) => {
      if (!(Z(s) && !F(s, t?.enableOnFormTags))) {
        if (u.current !== null) {
          const v = u.current.getRootNode();
          if ((v instanceof Document || v instanceof ShadowRoot) && v.activeElement !== u.current && !u.current.contains(v.activeElement)) {
            N(s);
            return;
          }
        }
        s.target?.isContentEditable && !t?.enableOnContentEditable || H(y, t?.delimiter).forEach((v) => {
          if (v.includes(t?.splitKey ?? "+") && v.includes(t?.sequenceSplitKey ?? ">")) {
            console.warn(
              `Hotkey ${v} contains both ${t?.splitKey ?? "+"} and ${t?.sequenceSplitKey ?? ">"} which is not supported.`
            );
            return;
          }
          const g = P(
            v,
            t?.splitKey,
            t?.sequenceSplitKey,
            t?.useKey,
            t?.description,
            t?.metadata
          );
          if (g.isSequence) {
            w = setTimeout(() => {
              h = [];
            }, t?.sequenceTimeoutMs ?? 1e3);
            const C = g.useKey ? s.key : K(s.code);
            if (D(C.toLowerCase()))
              return;
            h.push(C);
            const G = g.keys?.[h.length - 1];
            if (C !== G) {
              h = [], w && clearTimeout(w);
              return;
            }
            h.length === g.keys?.length && (d.current(s, g), w && clearTimeout(w), h = []);
          } else if (re(s, g, t?.ignoreModifiers) || g.keys?.includes("*")) {
            if (t?.ignoreEventWhen?.(s) || B && f.current)
              return;
            if (V(s, g, t?.preventDefault), !X(s, g, t?.enabled)) {
              N(s);
              return;
            }
            d.current(s, g), B || (f.current = !0);
          }
        });
      }
    }, O = (s) => {
      s.code !== void 0 && (_(K(s.code)), (t?.keydown === void 0 && t?.keyup !== !0 || t?.keydown) && p(s));
    }, q = (s) => {
      s.code !== void 0 && (I(K(s.code)), f.current = !1, t?.keyup && p(s, !0));
    }, E = u.current || o?.document || document;
    return E.addEventListener("keyup", q, o?.eventListenerOptions), E.addEventListener("keydown", O, o?.eventListenerOptions), l && H(y, t?.delimiter).forEach((s) => {
      l.addHotkey(
        P(
          s,
          t?.splitKey,
          t?.sequenceSplitKey,
          t?.useKey,
          t?.description,
          t?.metadata
        )
      );
    }), () => {
      E.removeEventListener("keyup", q, o?.eventListenerOptions), E.removeEventListener("keydown", O, o?.eventListenerOptions), l && H(y, t?.delimiter).forEach((s) => {
        l.removeHotkey(
          P(
            s,
            t?.splitKey,
            t?.sequenceSplitKey,
            t?.useKey,
            t?.description,
            t?.metadata
          )
        );
      }), h = [], w && clearTimeout(w);
    };
  }, [y, t, a]), u;
}
function le(e = !1) {
  const [n, r] = A(/* @__PURE__ */ new Set()), [i, u] = A(!1), f = k(
    (m) => {
      m.code !== void 0 && (m.preventDefault(), m.stopPropagation(), r((d) => {
        const t = new Set(d);
        return t.add(K(e ? m.key : m.code)), t;
      }));
    },
    [e]
  ), o = k(() => {
    typeof document < "u" && (document.removeEventListener("keydown", f), u(!1));
  }, [f]), y = k(() => {
    r(/* @__PURE__ */ new Set()), typeof document < "u" && (o(), document.addEventListener("keydown", f), u(!0));
  }, [f, o]), c = k(() => {
    r(/* @__PURE__ */ new Set());
  }, []);
  return [n, { start: y, stop: o, resetKeys: c, isRecording: i }];
}
export {
  fe as HotkeysProvider,
  U as isHotkeyPressed,
  de as useHotkeys,
  se as useHotkeysContext,
  le as useRecordHotkeys
};
